import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import PDFViewer from '@/components/PDFViewer/PDFViewer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Assessment',
  setup(__props) {

const router = useRouter();

const pdfViewerContainer = ref();

const urlBlobPDF = router.currentRoute.value.query.url as string;

onMounted(() => init());

const init = async () => {
  try {
    await validateUrlBlobPDF(urlBlobPDF);
    registerEvents();
  } catch (e) {
    console.error('PDF URL invalid.');
    alert('Sorry, invalid PDF URL. Please contact Support.');
    window.close();
  }
};

const registerEvents = () => {
  document.onselectstart = () => false;
  window.addEventListener('contextmenu', handlerContextMenu, false);
  window.addEventListener('keydown', handleKeyPress, false);
  window.addEventListener('keyup', handleKeyPress, false);

  registerPrintEvents();
};

const validateUrlBlobPDF = (url: string) => {
  const urlObj = new URL(url);
  const urlOriginObj = new URL(urlObj.origin);
  const urlHrefObj = new URL(new URL(url).href.replace('blob:', ''));

  return new Promise<void>((resolve, reject) => {
    if (
      urlObj.protocol !== 'blob:' ||
      urlOriginObj.hostname !== (process.env.VUE_APP_HOST as string) ||
      urlHrefObj.hostname !== (process.env.VUE_APP_HOST as string)
    ) {
      return reject();
    }

    return resolve();
  });
};

const handlerContextMenu = (e) => {
  e.preventDefault();
};

const stopKeyPress = (e) => {
  e.preventDefault();

  if (e.stopImmediatePropagation) {
    e.stopImmediatePropagation();
  } else {
    e.stopPropagation();
  }

  return false;
};

const handleKeyPress = (e) => {
  if (e.ctrlKey && e.code === 'KeyS') {
    return stopKeyPress(e);
  }

  if (e.ctrlKey && e.code === 'KeyP') {
    return stopKeyPress(e);
  }

  if (e.ctrlKey && e.shiftKey && e.code === 'KeyI') {
    return stopKeyPress(e);
  }

  if (e.code === 'F12') {
    return stopKeyPress(e);
  }

  if (e.code === 'PrintScreen') {
    navigator.clipboard.writeText('');
    return stopKeyPress(e);
  }
};

const registerPrintEvents = () => {
  // IE and Firefox fire before/after events
  window.addEventListener('beforeprint', handleBeforePrint, false);
  window.addEventListener('afterprint', handleAfterPrint, false);

  if ('matchMedia' in window) {
    // Chrome, Firefox, and IE 10 support mediaMatch listeners
    const mediaPrint = window.matchMedia('print');
    mediaPrint.addEventListener('change', (media) => {
      if (media.matches) {
        handleBeforePrint();
      } else {
        window.addEventListener('mouseover', handleAfterPrint, { once: true });
      }
    });
  }
};

const handleBeforePrint = () => {
  pdfViewerContainer.value.style.display = 'none';
};

const handleAfterPrint = () => {
  pdfViewerContainer.value.style.display = 'block';
  window.removeEventListener('mouseover', handleAfterPrint);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "pdfViewerContainer",
    ref: pdfViewerContainer
  }, [
    _createVNode(PDFViewer, { src: _unref(urlBlobPDF) }, null, 8, ["src"])
  ], 512))
}
}

})